<template>
    <span>
        <div>
            <!-- Begin:PageContent:Main -->
            <section id="content" class="image-bg2">
                <div class="container">
                    <div class="row">
                        <!-- Begin:Content-FlightSearchTabs-Booking -->
                        <div id="main" class="col-sm-8 col-md-9">
                            <sdr-shared-flightsearch-tabs modulo="booking"></sdr-shared-flightsearch-tabs>
                        </div>
                        <!-- Begin:Content-FlightSearchTabs-Booking -->


                        <!-- Begin:Content-SideBar-Direct -->
                        <div class="sidebar col-sm-4 col-md-3">
                            <sdr-promobox-direkt></sdr-promobox-direkt>
                        </div>
                        <!-- End:Content-SideBar-Direct -->
                    </div>
                </div>
            </section>
            <!-- End:PageContent:Main -->



            <!-- Begin:Content:FlightSearchResults -->
            <sdr-shared-flightsearchresults modulo="booking"></sdr-shared-flightsearchresults>
            <!-- End:Content:FlightSearchResults -->
        </div>
    </span>
</template>

<script>
    import FlightSearchTabs from '../shared/flightsearch/FlightSearchTabs.vue'; // Entire Tabs Construct (shared)
    import FlightSearchResults from '../shared/flightsearch/FlightSearchResults.vue'; // Content
    import PromoBoxDirect from '../shared/sidebar/Banner1.vue';


    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-shared-flightsearch-tabs': FlightSearchTabs,
            'sdr-shared-flightsearchresults': FlightSearchResults,
            'sdr-promobox-direkt': PromoBoxDirect,

        }, // eo components{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .alert.alert-error {
        background: #e22a24;
        color: #ffffff;
        margin-left: 15px;
        margin-right: 15px;
        font-size: 15px;
    }
</style>
